export default ({ request }) => ({
  changeOrderReviewListApi(data = {}) {
    return request({
      url: '/factory/changeOrderReview/list',
      method: 'post',
      data
    })
  },
  changeOrderReviewSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderReview/save',
      method: 'post',
      data
    })
  },
  changeOrderReviewDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderReview/detail',
      method: 'post',
      data
    })
  },
  changeOrderReviewDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderReview/del',
      method: 'post',
      data
    })
  },
})
